angular.module("searchContracts.components", ['app.services']).component("searchContracts", {
    templateUrl: "ng/components/munAuthorization/searchContracts/searchContracts.view.html",
    bindings: {},
    controllerAs: "searchContractsCtrl",
    controller: function SearchContracts($arcService) {
        var self = this;

        self.$onInit = function () {

            self.supportModel = {
                contractSelected: [],
                contractList: []
            }

            searchCotracts();
        };

        self.handleChange = function (property, value) {

            switch (property) {
                case "contracts":
                    break;
                default:
                    break;
            }
        }

        var searchCotracts = function () {
            $arcService
                .getImmContracts()
                .then(function (response) {
                    self.supportModel.contractList = response.listContratti;
                }).catch(function (error) {
                    console.error(error);
                });
        }
    }
});